module.exports = __webpack_public_path__ + "img/status-support.a87561d1.png";